import React from 'react';
import { Dialog } from "@headlessui/react"
import { Oval } from "react-loader-spinner"

export default function DeleteLotModal(props){

    const {lotNumber, handleDelete, setDeleteLotModal, deleteLotModal, loader,lotTitle, parameter }=props;

    return(
        <Dialog open={deleteLotModal} onClose={() => setDeleteLotModal(false)}
            data-te-modal-init
            className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-[#282828cc]"
            id="exampleModalXl3"
            tabIndex="-1"
            aria-labelledby="exampleModalXlLabel"
            aria-modal="true"
            role="dialog">
            <Dialog.Panel
                data-te-modal-dialog-ref
                className="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] 
                    items-center mx-3 transition-all duration-300 ease-in-out min-[640px]:mx-auto
                    min-[640px]:mt-7 min-[640px]:min-h-[calc(100%-3.5rem)] min-[640px]:max-w-[480px]">
                <div
                    className="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white 
                    bg-clip-padding text-current shadow-lg outline-none py-[47px]">
                    <Dialog.Title>
                        {/* <!--Close button--> */}
                        <p className="text-center leading-normal text-[16px] text-[#343434]
                            font-medium" id="confirm-msg" >
                            Are you sure you want to delete Lot {lotNumber}?</p>
                        <p className="sm:px-[90px] px-10 pb-6 text-center leading-normal text-[16px] text-[#343434]
                            font-medium" >This cannot be reverted.</p>
                    </Dialog.Title>
                    {/* <!--Modal body--> */}
                    <div className="relative">
                        <p className="sm:px-[90px] px-10 text-center pb-6 leading-normal text-[14px] text-[#717179]
                            font-medium" data-testid='lot-title'>{lotTitle}</p>
                        <div className="flex justify-center">
                            <button type='button' data-testid="cancel-button"
                                onClick={()=>setDeleteLotModal(false)} id="cancel-delete"
                                className="px-[31px] py-[12px] border esm:w-[135px] w-[100px] border-[#A1A1A9] 
                            bg-[#fffff] hover:bg-[#EFF1F8] text-[#282828] leading-normal font-medium text-[14px] rounded-[6px]"  
                                data-te-modal-dismiss
                                aria-label="Close">
                                Cancel
                            </button>
                            <a href="Lot-listing-page.html" className="ml-3 export-btn">
                                <button data-testid='confirm-delete' 
                                    disabled={loader}
                                    type='button' onClick={(e)=>{ e.preventDefault(); 
                                        handleDelete(parameter ? parameter : lotNumber)}}
                                    className="flex justify-center items-center px-[31px] esm:w-[135px] w-[100px] py-[12px] 
                                    bg-[#282828] text-[#FFFFFF] leading-normal font-medium text-[14px] rounded-[6px] 
                                    disabled:bg-[#A1A1A9] hover:bg-[#3F3F45]" 
                                    data-te-modal-dismiss
                                    aria-label="Close">
                                    Delete
                                    {loader&& 
                                    <Oval
                                        height={20}
                                        width={50}
                                        color="#FFFFFF"
                                        wrapperClass=""
                                        visible={true}
                                        ariaLabel='oval-loading'
                                        secondaryColor="#000000"
                                        strokeWidth={2}
                                        strokeWidthSecondary={2}
                                    />
                                    }
                                </button>
                            </a> 
                        </div>
                    </div>
                </div>
            </Dialog.Panel>
        </Dialog>
    )
}